import request from "src/utils/request";
import { useParams } from "react-router-dom";
import useApi from "../../../utils/api/use-api";
import { sleep } from "../../../utils/api/mock-utils";
import { useAuth } from "../../../components/providers/auth-context";

const useIntegrationsApiTeams = () => {
    const { teamId } = useParams();
    const { userHasTeamsSubscription } = useAuth();
    const getMockData = async () => {
        await sleep();
        return {
            integrations: [
                { name: "slack", connected: true },
                { name: "gitlab", connected: false },
                { name: "gitlabSelfManaged", connected: false },
                { name: "github", connected: true },
                { name: "google", connected: true },
                { name: "microsoft", connected: true },
                { name: "jira", connected: true },
                { name: "notion", connected: false },
            ],
        };
    };
    return useApi(
        ({ team }) => {
            if (process.env.MOCK_INTEGRATIONS === "true" || !userHasTeamsSubscription) {
                return getMockData();
            }
            return request(`/api/teams/${team}/integrations`);
        },
        !!teamId,
        { team: teamId }
    );
};

export default useIntegrationsApiTeams;
